import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { eContactCardType } from '@hub/generated/enums';
import { OverlayPanel } from 'primeng/overlaypanel';
import { VenueContactCardComponent } from './venue-contact-card.component';

@Component({
  selector: 'contact-card',
  templateUrl: 'contact-card.component.html'
})
export class ContactCardComponent implements OnInit {
  @Input() contactCard: any;
  @Input() iconType: string;
  @ViewChild(OverlayPanel) overlayPanel: OverlayPanel;
  @ViewChild(VenueContactCardComponent) venueContactCardComponent: VenueContactCardComponent;

  public isShow: boolean;
  private isVenue: boolean;
  private isLocation: boolean;
  private isMouseOnContactCard: boolean;
  protected Type = eContactCardType;

  ngOnInit(){
  }

  showContactCard(event, target) {
    this.isShow = true;
    this.isVenue =
      this.contactCard != null &&
      this.contactCard.ContactType ===eContactCardType.Venue? true: false;
    setTimeout(() => {
      if (this.isShow && !!this.contactCard && this.contactCard !== undefined && this.contactCard.FullName != undefined && this.contactCard.Address != null) {
        this.overlayPanel.show(event, target);
        if (this.isVenue && this.venueContactCardComponent != null) {
          this.venueContactCardComponent.refreshMap();
        }
      }
    }, 1000);
  }

  hideContactCard() {
    setTimeout(() => {
      if (!this.isMouseOnContactCard) {
        this.isShow = false;
        if (!!this.overlayPanel) this.overlayPanel.hide();
      }
    }, 500);
  }

  onMouseLeavedCard() {
    this.isMouseOnContactCard = false;
    this.hideContactCard();
  }
  onMouseOverCard() {
    this.isMouseOnContactCard = true;
  }
}
